/*
 * @Author: lidan
 * @Date: 2020-11-11 09:29:24
 * @LastEditTime: 2020-11-19 15:00:04
 * @LastEditors: lidan
 * @Description: 订单应付费用api
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\orderPayable.js
 */

import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取订单应付费用表格数据
export function orderReportPayable(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/orderReport/payable`,
    method: "post",
    data
  });
}
// 导出订单应付费用
export function exportOrderPayable(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/orderReport/export/payable`,
    method: "post",
    data
  });
}
